import { useEffect, useState } from 'react';
import { avatarColor } from '../lib/colors';

function initials(name: string): string {
  return name.split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase() || '?';
}

interface Props {
  userId?: string | null;
  /** Аватар группового чата (альтернатива userId — ровно один из них должен быть задан). */
  chatId?: string | null;
  name: string;
  size?: number;
  /** Меняется при смене аватара — сбрасывает кэш/ошибку картинки. */
  version?: string | number | null;
}

/** Аватар: картинка с /api/v1/users/{id}/avatar или /api/v1/chats/{id}/avatar, иначе — инициалы. */
export default function Avatar({ userId, chatId, name, size = 40, version }: Props) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [userId, chatId, version]);
  const base = chatId ? `/api/v1/chats/${chatId}/avatar` : userId ? `/api/v1/users/${userId}/avatar` : null;
  const showImg = !!base && !failed;
  return (
    <div
      className="avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        ...(showImg ? {} : { background: avatarColor(chatId ?? userId ?? name) }),
      }}
    >
      {showImg ? (
        <img
          src={base + (version ? `?v=${version}` : '')}
          alt=""
          className="avatar-img"
          onError={() => setFailed(true)}
        />
      ) : (
        initials(name)
      )}
    </div>
  );
}
